module.exports = __webpack_public_path__ + "img/arrow-down-icon.851317f5.png";